const notificationContextReducer = (state, action) => {
    return action.payload.notificationJob ?? {
        jobId: null,
        jobType: null
    };
};

export { notificationContextReducer };
